import { FC, ReactNode } from 'react';

import { VSpacing } from '@hh.ru/magritte-ui';

import { BannerExamplesSection } from 'components/common/MagritteBannerPreviewSidebar/BannerExamplesSection/BannerExamplesSection';
import { BannerPreviewSection } from 'components/common/MagritteBannerPreviewSidebar/BannerPreviewSection/BannerPreviewSection';

interface MagritteBannerPreviewSidebarProps {
    showBannerExamples?: boolean;
    title: string;
    text: string;
    image?: string;
    bannerImageBadge?: ReactNode;
    vacancyId?: number | null;
}

export const MagritteBannerPreviewSidebar: FC<MagritteBannerPreviewSidebarProps> = ({
    showBannerExamples,
    title,
    text,
    image,
    bannerImageBadge,
    vacancyId,
}) => {
    return (
        <div>
            <BannerPreviewSection
                title={title}
                text={text}
                image={image}
                bannerImageBadge={bannerImageBadge}
                vacancyId={vacancyId}
            />
            {showBannerExamples && (
                <>
                    <VSpacing default={32} />
                    <BannerExamplesSection />
                </>
            )}
            <VSpacing default={32} />
        </div>
    );
};
